import { useState } from 'react';
import { reviews } from '@/mocks/homeData';

export default function ReviewsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            用户<strong className="text-primary-500">真实评价</strong>
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            听听快猫视频的用户们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {reviews.slice(0, 3).map((review, index) => (
            <div
              key={index}
              className="p-6 rounded-2xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                "{review.comment}"
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <span className="text-sm font-medium text-foreground-950">{review.name}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="hidden lg:grid grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {reviews.slice(3, 5).map((review, index) => (
            <div
              key={index + 3}
              className="p-6 rounded-2xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                "{review.comment}"
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <span className="text-sm font-medium text-foreground-950">{review.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}